import { render, staticRenderFns } from "./gameCom.vue?vue&type=template&id=5d2996be&scoped=true"
import script from "./gameCom.vue?vue&type=script&lang=ts"
export * from "./gameCom.vue?vue&type=script&lang=ts"
import style0 from "./gameCom.vue?vue&type=style&index=0&id=5d2996be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2996be",
  null
  
)

export default component.exports